'use strict';

import './paymentCalculator.scss';
import controller from './paymentCalculator.controller';

function directive() {
    return {
        bindings: {
            calculatorData: "@"
        },
        link,
        restrict: 'EA',
        controller,
        controllerAs: 'ctrl'
    };

    function link(scope, element, attrs) {
        scope.ctrl.setup(attrs.calculatorData);
    }
}
directive.$inject = [];

export default directive;